import React from 'react';

/**
 * Error 404 - Page Not Found
 *
 * @param {*} { }
 * @returns
 */
const PageNotFound = () => {
  return (
    <>
      <h1>404 - Page Not Found!</h1>
    </>
  );
};

export default PageNotFound;
